import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {Body} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import React, {FC} from "react"
import {useDeal} from "@irati/deals/hooks"
import useBasket from "@irati/checkout/utils/basket/useBasket"
import Loading from "@irati/ui/src/Loading"
import {PointsBreakdown} from "@irati-web/perks/src/components/OrderSummary/Summaries/PointsBreakdown"
import SummaryProductInfo from "./SummaryProductInfo"
import {BalanceLeft} from "./styled"

const Summary: FC = () => {
  const {deal, walletForDeal, load, isPointsBlendDeal} = useDeal()
  const {breakdown, pointBreakdown} = useBasket()
  const {currency, amount} = breakdown.total ?? {}

  return (
    <Flex direction="column" width="100%">
      <Loading load={load}>
        <SummaryProductInfo cardImage={deal.cardImage!} header={deal.header!} />
        <Hr />
        <Flex gap={theme.spacing.one}>
          <Icon icon={IconTypes.package} size={25} />
          <Body>
            <FormattedMessage id="flexiRewards.merchandise.checkout.summary.tracked" />
          </Body>
        </Flex>
        <Hr />
        <Flex justifyContent="space-between" width="100%" alignItems="center">
          <Body weight="bold">
            <FormattedMessage id="flexiRewards.merchandise.checkout.summary.total" />
          </Body>
          <Body weight="bold">
            <FormattedCurrency isCents currency={currency!} value={amount!} />
          </Body>
        </Flex>
        {pointBreakdown && isPointsBlendDeal ? (
          <BalanceLeft>
            <PointsBreakdown pointBreakdown={pointBreakdown} />
          </BalanceLeft>
        ) : (
          <BalanceLeft>
            <Body small marginRight={1}>
              <FormattedMessage id="flexiRewards.merchandise.checkout.summary.balance.first" />
            </Body>
            {/* TODO: can be removed after everyone is on points blend */}
            <FormattedCurrency isCents currency={currency!} value={walletForDeal.amount! - amount!} />
            <Body small marginLeft={1}>
              <FormattedMessage id="flexiRewards.merchandise.checkout.summary.balance.second" />
            </Body>
          </BalanceLeft>
        )}
      </Loading>
    </Flex>
  )
}

export default Summary
